export enum PopUpInputsList {
  none = 'none',
  date = 'date',
}
